import { NgIf } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { FuseFullscreenComponent } from '@fuse/components/fullscreen';
import { FuseLoadingBarComponent } from '@fuse/components/loading-bar';
import { FuseNavigationItem, FuseNavigationService, FuseVerticalNavigationComponent } from '@fuse/components/navigation';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { Navigation } from 'app/core/navigation/navigation.types';
import { LanguagesComponent } from 'app/layout/common/languages/languages.component';
import { MessagesComponent } from 'app/layout/common/messages/messages.component';
import { NotificationsComponent } from 'app/layout/common/notifications/notifications.component';
import { QuickChatComponent } from 'app/layout/common/quick-chat/quick-chat.component';
import { SearchComponent } from 'app/layout/common/search/search.component';
import { ShortcutsComponent } from 'app/layout/common/shortcuts/shortcuts.component';
import { UserComponent } from 'app/layout/common/user/user.component';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'ainop-v-layout',
    templateUrl: './ainop-v.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [FuseLoadingBarComponent, FuseVerticalNavigationComponent, MatButtonModule, MatIconModule, FuseFullscreenComponent, NgIf, RouterOutlet],
})
export class AinopVLayoutComponent implements OnInit, OnDestroy {
    isScreenSmall: boolean;
    navigation: Navigation;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    navigationItems: FuseNavigationItem[];

    tipo: string

    /**
     * Constructor
     */
    constructor(
        private _router: Router,
        private _navigationService: NavigationService,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _fuseNavigationService: FuseNavigationService,
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for current year
     */
    get currentYear(): number
    {
        return new Date().getFullYear();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {

        // Subscribe to navigation data
        this._navigationService.navigation$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((navigation: Navigation) =>
            {
                const ll = this._router.url.split('/')

                console.log(ll)
                ///DA VEDERE!!!!!!!!!!!!
                if (ll[1]==='settore-urbanistica'){
                    this.tipo = 'Ponti';
                    this.navigationItems = navigation.ponte;
                    const ponteid = ll[2];
                    this.navigationItems.map((el) => {
                        if (el.id != 'scrivania' && el.children)
                            el.children.map((x) => {
                                if (!x.meta) {
                                    x.meta = x.link
                                }
                                x.link = `/ponti/${ponteid}/${x.meta}`

                                if (x.children) {
                                    x.children.map((y) => {
                                        if (!y.meta) {
                                            y.meta = y.link
                                        }
                                        y.link = `/ponti/${ponteid}/${y.meta}`
                                    })
                                }

                            })
                    })
                }
                else if (ll[1]==='oci'){
                    this.tipo = 'OCI';
                    const ociid = ll[2];
                    this.navigationItems = navigation.ponte;
                    this.navigationItems.map((el) => {
                        if (el.id != 'scrivania' && el.children)
                            el.children.map((x) => {
                                if (!x.meta) {
                                    x.meta = x.link
                                }
                                x.link = `/oci/${ociid}/${x.meta}`

                                if (x.children) {
                                    x.children.map((y) => {
                                        if (!y.meta) {
                                            y.meta = y.link
                                        }
                                        y.link = `/oci/${ociid}/${y.meta}`
                                    })
                                }

                            })
                    })
                }


            });

        // Subscribe to media changes
        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({matchingAliases}) =>
            {
                // Check if the screen is small
                this.isScreenSmall = !matchingAliases.includes('md');
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle navigation
     *
     * @param name
     */
    toggleNavigation(name: string): void
    {
        // Get the navigation
        const navigation = this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(name);
        if ( navigation )
        {
            // Toggle the opened status
            navigation.toggle();
        }
    }
}
